<template>
    <div>
        <h3>Seller Info</h3>
        <v-text-field v-model="sellerData.seller_firstname" label="Seller First Name"></v-text-field>
        <v-text-field v-model="sellerData.seller_lastname" label="Seller Last Name"></v-text-field>
    </div>
</template>


<script>
    export default {
        name: 'SellerInfo',
        props: [
            'sellerData'
        ],
    }
</script>


// WEBPACK FOOTER //
// src/components/prospectus-sections/SellerInfo.vue